<template>
    <div class="main-box mh-a">
        <iristar-dividing>{{ $t("software.title") }}</iristar-dividing>
        <div class="p30" v-for="(item, index) in software" :key="`${index}_software`">
            <p :id="item.id" style="height: 0;position: relative;top: -60px;"></p>
            <div class="software-title">{{ item.title }}</div>
            <div v-for="(soft, dx) in item.introduce" :key="`${dx}_intr`">
                <div v-if="soft.type === 'img'" style="    text-align: center;">
                    <el-image style="width: 80%;" class="w-total" :src="soft.inner" fit="contain"></el-image>
                </div>
                <p class=" lh30 fs14  soft-text" v-else-if="soft.type === 'html'" v-html="soft.inner">
                </p>
                <p class=" lh30 ext-indent  text-indent fs14  soft-text" v-else-if="soft.type === 'subtitle'"
                    v-html="soft.inner">
                </p>

                <p class="text-indent lh30 fs14  soft-text" v-else-if="soft.type === 'text'">{{ soft.inner }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import IristarDividing from "@/components/IristarDividing";
import SoftwareList from "@/assets/software/aisoftware";
import SoftwareListEn from "@/assets/software/software-en";
export default {
    components: { IristarDividing },
    name: "IristarSoftware",
    computed: {
        software() {
            return this.$store.state.language === "zh"
                ? SoftwareList
                : SoftwareListEn;
        },
    },


};
</script>

<style lang="less" scoped>
.software-title {
    border-left: 5px solid rgba(#14284b, 0.8);
    text-indent: 8px;
    font-size: 20px;
    margin-bottom: 12px;
}
</style>